import { Link } from 'react-router-dom'
import { AlertTriangle } from '@ensafely/checker-ui'
import { useTenantStatus } from './TenantStatusContext'

export function SuspendedBanner() {
  const { isSuspended } = useTenantStatus()

  if (!isSuspended) return null

  return (
    <div className="w-full bg-amber-50 border-b border-amber-200 dark:bg-amber-950/30 dark:border-amber-800 px-4 py-2 flex items-center gap-2 text-amber-800 dark:text-amber-200 text-sm">
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <span>
        Your account is suspended. You have read-only access. Contact support or update your
        billing to restore full access.
      </span>
      <Link
        to="/account/billing"
        className="ml-auto flex-shrink-0 font-medium underline hover:no-underline"
      >
        Update Billing →
      </Link>
    </div>
  )
}
